module.exports = __webpack_public_path__ + "static/bottom-ebde3f72dd918bbb7d0ad7bcd5ce8fe4.png";